import { forwardRef, type FormEvent } from 'react'
import {
  AiSearchInput as AiSearch,
  type AiSearchInputRef,
} from './ai-search-input/ai-search-input'

type AiSearchInputProps = {
  placeholders?: string[]
  showSubmitButton?: boolean
  onFocus?: (event: FormEvent<HTMLInputElement>) => void
}

export const AiSearchInput = forwardRef<AiSearchInputRef, AiSearchInputProps>(
  (props: AiSearchInputProps, ref) => (
    <AiSearch
      ref={ref}
      aria-label={'AI powered search input'}
      placeholders={props.placeholders}
      showSubmitButton={props.showSubmitButton}
      onFocus={props.onFocus}
    />
  ),
)

AiSearchInput.displayName = 'AiSearchInput'
